/*
 * Copyright (c) 2020. American Express Company
 */

import { FullUserModel, UserModel } from 'src/types/user.model';
import { FETCH_USER_ERROR, FETCH_USER_PENDING, FETCH_USER_SUCCESS, SET_USER } from '../types';

export const setUser = (user: FullUserModel): { type: string; payload: FullUserModel } => ({
    type: SET_USER,
    payload: user
});

export const fetchUserPending = (): { type: string } => {
    return {
        type: FETCH_USER_PENDING
    };
};

export const fetchUserSuccess = (user: UserModel): { type: string; payload: UserModel } => {
    return {
        type: FETCH_USER_SUCCESS,
        payload: user
    };
};

export const fetchUserError = (error: any): { type: string; error: Error } => {
    return {
        type: FETCH_USER_ERROR,
        error
    };
};
